export default __webpack_public_path__ + "static/media/email-red.a384fa8e.svg";